import { Injectable } from '@angular/core';
import { Socket } from 'ngx-socket-io';
import { BehaviorSubject, Observable } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class SocketService {
  private connectionStatus = new BehaviorSubject<boolean>(false);
  private reconnectAttempts = 0;
  private maxReconnectAttempts = 5;

  constructor(private socket: Socket, private authService: AuthService) {
    this.setupConnectionHandlers();
  }

  private setupConnectionHandlers(): void {
    this.socket.on('connect', () => {
      console.log(
        'Socket connected successfully! Socket ID:',
        this.socket.ioSocket.id
      );

      this.connectionStatus.next(true);
      this.reconnectAttempts = 0;

      const userId = this.authService.getNestedUserProperty('merchant', '_id');
      if (userId) {
        this.registerDashboard(userId);
      }
    });

    this.socket.on('disconnect', () => {
      // console.log('Socket disconnected');
      this.connectionStatus.next(false);
      this.handleDisconnect();
    });

    this.socket.on('connect_error', (error: any) => {
      console.error('Socket connection error:', error);
      this.handleDisconnect();
    });
  }

  private handleDisconnect(): void {
    if (this.reconnectAttempts < this.maxReconnectAttempts) {
      this.reconnectAttempts++;
      const delay = 1000 * Math.pow(2, this.reconnectAttempts);
      console.log(
        `Attempting to reconnect in ${delay / 1000} seconds... (Attempt ${
          this.reconnectAttempts
        }/${this.maxReconnectAttempts})`
      );
      setTimeout(() => {
        this.connect();
      }, delay); // Exponential backoff
    }
  }

  connect(): void {
    if (!this.socket.ioSocket.connected) {
      this.socket.connect();
    }
  }

  disconnect(): void {
    this.socket.disconnect();
  }

  isConnected(): Observable<boolean> {
    return this.connectionStatus.asObservable();
  }

  registerDashboard(userId: string): void {
    if (this.socket.ioSocket.connected) {
      this.socket.emit('register_dashboard', userId);
    }
  }

  unregisterDashboard(userId: string): void {
    if (this.socket.ioSocket.connected) {
      this.socket.emit('unregister_dashboard', userId);
    }
  }
}
